/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//CUSTOM CTA BJORN IRONFINGER

if(document.querySelector('#shopify-section-cart-template')){
  
  const countrySelect = document.querySelector('#shipping-estimator-country');

  if(!document.querySelector(".warning-message")){
    var child = document.createElement("p");
    child.className = "warning-message";
    
    
    child.style.display = "none";
    child.style.flexShrink = "0";
    document.querySelector(".form__input-row").appendChild(child);
    
    
    var contactBtn = document.createElement("a");
    contactBtn.className = "button button--primary button--full button--large btnContactCart";
    contactBtn.innerHTML = "Contact us";
    contactBtn.style.display = "none";
    
    contactBtn.style.flexShrink = "0";
    document.querySelector(".cart-recap form").appendChild(contactBtn);
    
    
    if(document.documentElement.lang === "fr"){
      	child.innerHTML = "Contactez-nous pour obtenir un prix de livraison pour cette région.<br><a href='mailto:info@disconst.com'>info@disconst.com</a>";
    	contactBtn.href = "https://disconst.myshopify.com/pages/contactez-nous"
    }else{
    	child.innerHTML = "Contact us to get a shipping fee for that region.<br><a href='mailto:info@disconst.com'>info@disconst.com</a>";
    	contactBtn.href = "https://disconst.myshopify.com/pages/contact-us"
    }
  }

  var messageVisible = false;
  
	const specificsProvincesSelect = document.querySelector('#shipping-estimator-province');
  
  	//let provinces = ["Yukon", "Prince Edward Island", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut"];
    
    /*for (i = 0; i < provinces.length; i++){
        var opt = document.createElement('option');
        opt.value = provinces[i];
        opt.innerHTML = provinces[i];
        specificsProvincesSelect.appendChild(opt);
    }*/
  
    
    specificsProvincesSelect.addEventListener('change', (event) => {
  	  var zipCodeInput       = document.querySelector(".form__input-wrapper:nth-child(3)");
      var formEstimateSubmit = document.querySelector(".form__input-wrapper .form__submit");
      
      if(specificsProvincesSelect.value === "Yukon" 
         || specificsProvincesSelect.value === "Prince Edward Island" 
         || specificsProvincesSelect.value === "Newfoundland and Labrador" 
         || specificsProvincesSelect.value === "Northwest Territories" 
         || specificsProvincesSelect.value === "Nova Scotia" 
         || specificsProvincesSelect.value === "Nunavut"){
        
        if(messageVisible == false){
          messageVisible = true;
          zipCodeInput.style.display = 'none';
          document.querySelector(".warning-message").style.display = "block";
          formEstimateSubmit.style.display = 'none';
          
          document.querySelector(".btnContactCart").style.display = "block";
          document.querySelector(".cart-recap__checkout").style.display = "none";
        }
      }
      else{
        messageVisible = false;
      	document.querySelector(".warning-message").style.display = 'none';
        zipCodeInput.style.display = 'block';
        formEstimateSubmit.style.display = 'block';
        document.querySelector(".btnContactCart").style.display = "none";
        document.querySelector(".cart-recap__checkout").style.display = "block";
      }

    });
}
